import "./right-side-bar.css";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { logoutFunc } from "../../../../store/custom-actions/auth/logout-actons/LogoutSlicer";
import Swal from "sweetalert2";
import defaultUserImage from "../../../../media/images/user (2).png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import emptyImg from "../../../../media/images/planet.png";
import { ContextApi } from "../../../../store/ContextApi";
import { getNotficationsFunc } from "../../../../store/custom-actions/notfications-actions/GetNotficationSlicer";
import { readAllNotficationsFunc } from "../../../../store/custom-actions/notfications-actions/ReadAllNotficationsSlicer";
import { refreshTokenFunc } from "../../../../store/custom-actions/auth/RefreshTokenSlicer";
import { toast } from "react-toastify";
import ToggelerLang from "./toggeler-lang/ToggelerLang";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";

function NotficationsList({ show, onHide, notfications, notficationsLoading }) {
  const { t, i18n } = useTranslation();
  const [animate, setAnimate] = useState(false);

  const dir = i18n.dir();

  useEffect(() => {
    setAnimate(!notficationsLoading);
  }, [notficationsLoading]);

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement={dir === "rtl" ? "start" : "end"}
      className={`notifications-offcanvas ${dir}`}
    >
      <Offcanvas.Header>
        <Offcanvas.Title className="d-flex align-items-center">
          <i className="fa-solid fa-bell me-2 text-primary"></i>
          {t("Notifications")}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {notficationsLoading ? (
          <div className="d-flex justify-content-center gap-2">
            <Spinner animation="grow" variant="primary" />
            <Spinner animation="grow" variant="primary" />
            <Spinner animation="grow" variant="primary" />
          </div>
        ) : notfications && notfications.length > 0 ? (
          <div
            className="notifications-list overflow-auto"
            style={{ maxHeight: "400px" }}
          >
            {notfications.map((note, index) => {
              const noteDate = new Date(note.created_at);
              const readDate = new Date(note.read_at);

              const { title, subject, sender } = note.data;

              return (
                <div
                  key={index}
                  className={`notification-card p-3 mb-3 rounded shadow-sm ${
                    animate ? "fade-in" : ""
                  }`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa-solid fa-tag text-primary me-2"></i>
                    <h6 className="mb-0 fw-bold">{title}</h6>
                  </div>

                  <p className="mb-2 text-muted">{subject}</p>

                  <div className="small text-secondary">
                    <div className="mb-1">
                      <i className="fa-solid fa-user me-1 text-primary"></i>
                      {t("Sender")}: <strong>{sender}</strong>
                    </div>
                    <div className="mb-1">
                      <i className="fa-solid fa-calendar-days me-1 text-success"></i>
                      {t("Sent_on")}: {noteDate.toLocaleDateString()}
                    </div>
                    <div>
                      <i className="fa-solid fa-eye me-1 text-info"></i>
                      {t("Read_on")}: {readDate.toLocaleDateString()}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center">
            <img
              src={emptyImg}
              alt="empty"
              className="mb-3"
              style={{ width: "100px" }}
            />
            <p className="text-muted">{t("No_notifications")}</p>
          </div>
        )}
      </Offcanvas.Body>

      <div className="p-3 border-top">
        <Button variant="primary" className="w-100" onClick={onHide}>
          {t("Close")}
        </Button>
      </div>
    </Offcanvas>
  );
}

const RightSidebar = ({ onNote, showRightSidebar }) => {
  const { t } = useTranslation();
  const [rightSelect, setRightSelect] = useState("Eng");
  const user = JSON.parse(window.localStorage.getItem("user"));
  const dispatch = useDispatch();
  const { loading: logoutLoading } = useSelector((state) => state.logoutSlicer);
  const { loading: switchLangLoading, data: languageData } = useSelector(
    (state) => state.getLanguageSettingsSlicer
  );
  const navigate = useNavigate();
  const { loading: getNotficationsLoading, data } = useSelector(
    (state) => state.getNotficationSlicer
  );
  const { loading: readAllNotsLoading } = useSelector(
    (state) => state.readAllNotficationsSlicer
  );
  const { loading: refreshTokenLoading } = useSelector(
    (state) => state.refreshTokenSlicer
  );
  const [showNotficationsList, setShowNotficationsList] = useState();
  const contextApi = useContext(ContextApi);
  const notficationsApi = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/notifications`;
  const refreshTokenApi = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/refresh`;
  const [notficationsList, setNotficationsList] = useState([]);
  const [unReadNotficationsCount, setUnReadNotficationsCount] = useState(0);
  const [unReadNotfications, setUnReadNotfications] = useState([]);
  const [readNotfications, setReadNotfications] = useState([]);
  const logoutFunction = () => {
    try {
      dispatch(logoutFunc());
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
      });
    }
  };
  const getNotfications = async () => {
    dispatch(getNotficationsFunc(notficationsApi));
  };
  const readNotficationsFunction = async () => {
    dispatch(readAllNotficationsFunc(notficationsApi)).then(
      (result) => result.payload.success === true && getNotfications()
    );
  };
  useEffect(() => {
    getNotfications();
  }, []);
  useEffect(() => {
    data &&
      data.read_notifications &&
      setNotficationsList(data.read_notifications);
    data &&
      data.unread_notifications_count &&
      setUnReadNotficationsCount(data.unread_notifications_count);
    data &&
      data.unread_notifications &&
      setUnReadNotfications(data.unread_notifications);
    data &&
      data.read_notifications &&
      setReadNotfications(data.read_notifications);
  }, [data]);
  const refreshFunction = () => {
    try {
      dispatch(refreshTokenFunc(refreshTokenApi)).then((result) => {
        if (result.payload.success === true) {
          toast.success(`${result.payload.message} !`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      });
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
      });
    }
  };

  return (
    <>
      <div
        className={`right-sidebar shadow d-flex flex-column justify-content-between 
      ${
        languageData?.defaultLang?.slug === "ar"
          ? `rounded-end position-fixed start-0 ${
              !showRightSidebar ? "d-block" : "d-none"
            }`
          : `rounded-start position-fixed end-0 ${
              !showRightSidebar ? "d-block" : "d-none"
            }`
      }
      align-items-center bg-white h-50 my-3`}
        style={{ zIndex: 2 }}
      >
        {/* User Dropdown */}
        <ul className="list-unstyled m-0">
          <Dropdown as="li" className="nav-item dropdown header-profile">
            <Dropdown.Toggle variant="" as="a" className="nav-link c-pointer">
              <img
                src={user?.image ? user?.image : defaultUserImage}
                width={30}
                height={30}
                alt="user"
                className="rounded-circle"
              />
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Link
                to="/admin-profile"
                className="dropdown-item d-flex align-items-center"
              >
                <i className="bi bi-person-circle me-2 text-primary"></i>
                {t("Profile")}
              </Link>

              <Link
                to="#"
                className="dropdown-item d-flex align-items-center"
                onClick={() => refreshFunction()}
              >
                <i className="bi bi-arrow-repeat me-2 text-success"></i>
                {refreshTokenLoading ? "loading.." : "Refresh Session"}
              </Link>

              <Link
                to="#"
                className="dropdown-item d-flex align-items-center"
                onClick={() => logoutFunction()}
              >
                <i className="bi bi-box-arrow-right me-2 text-danger"></i>
                {logoutLoading ? "loading.." : "Logout"}
              </Link>
            </Dropdown.Menu>
          </Dropdown>
        </ul>

        {/* Social & Actions */}
        <div className="sidebar-social-link my-3">
          <ul className="list-unstyled d-flex flex-column gap-2">
            {/* Contacts */}
            <li className="nav-item">
              <button
                className="btn btn-primary text-white w-100 d-flex justify-content-center align-items-center"
                onClick={() => navigate("/contacts")}
                title={t("Contacts")}
              >
                <i className="bi bi-envelope fs-4"></i>
              </button>
            </li>

            {/* Notifications */}
            <li className="nav-item position-relative">
              <button
                className="btn btn-primary text-white w-100 d-flex justify-content-center align-items-center position-relative"
                onClick={() => {
                  readNotficationsFunction();
                  setShowNotficationsList(true);
                }}
                title={t("Notifications")}
              >
                <i className="bi bi-bell fs-4"></i>
                {parseInt(unReadNotficationsCount) >= 1 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-white text-danger border">
                    {unReadNotficationsCount}
                  </span>
                )}
              </button>
            </li>
          </ul>
        </div>

        {/* Language Toggler */}
        <ToggelerLang />
      </div>

      <NotficationsList
        show={showNotficationsList}
        onHide={() => setShowNotficationsList(false)}
        notficationsLoading={readAllNotsLoading}
        notfications={readNotfications}
      />
    </>
  );
};

export default RightSidebar;
